function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Emoji_applause");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "P_St_A",
  transform: "translate(-501.000000, -480.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(409.000000, 473.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Emoji_applause",
  transform: "translate(92.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "skin",
  transform: "translate(2.268000, 0.000000)",
  fill: "#FCEA2B",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.7651316,15.1190928 L16.363809,12.292749 C16.1704998,11.150622 16.0511652,9.537885 15.6455334,6.8972148 C14.7107016,6.2113338 13.5850932,7.5209904 13.3007616,8.6487156 L12.260241,1.8748422 C12.0504132,0.508977 9.5637402,0.7873362 9.8221788,2.4699276 L10.6109892,7.7912982 L9.6549138,1.3810608 C9.429021,-0.0894726 6.9581862,-0.23436 7.362684,2.398788 C7.161021,1.085994 4.6850076,1.1050074 4.9885416,3.0810024 L5.2812648,5.1340716 L5.319594,5.4396468 L5.236056,4.7978406 C5.0543892,3.6152298 2.941407,3.8991834 3.1756536,5.4243 L3.584007,7.8552558",
  id: "Path",
  stroke: "#FCEA2B",
  strokeWidth: 0.756,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.0628952,8.789823 C2.8562058,7.5831336 4.7010348,5.88357 5.6805462,6.8630814 L11.8454238,13.027959 L10.5384888,11.721024 C10.0995552,10.6409268 10.2327246,8.914941 11.394999,8.914941 C13.288779,10.808721 14.5978308,12.2917284 15.4313586,13.1001948 C17.7849756,15.4538118 17.7849756,19.2697974 15.4313586,21.6234522 C13.0777416,23.977107 9.3127482,23.9889384 6.9591312,21.6353214 L0.4429026,15.1190928 C-0.6508404,14.0253498 0.8886024,12.5428338 1.736721,13.3909524 L5.4635742,17.1872064 L2.2225266,13.8857922 L0.5185404,12.1500918 C-0.8985438,10.7330076 1.0913994,9.2493576 2.032884,10.1908422 C0.1445094,8.3024676 2.2274406,6.9543684 3.2820606,8.0089506 L8.3438208,13.0707108",
  id: "Path"
})), /*#__PURE__*/React.createElement("g", {
  id: "line",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.756
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.3308952,8.789823 C5.1242058,7.5831336 6.9690348,5.88357 7.9485462,6.8630814 L14.1134238,13.027959 L12.8064888,11.721024 C12.3675552,10.6409268 12.5007246,8.914941 13.662999,8.914941 C15.556779,10.808721 16.8658308,12.2917284 17.6993586,13.1001948 C20.0529756,15.4538118 20.0529756,19.2697974 17.6993586,21.6234522 C15.3457416,23.977107 11.5807482,23.9889384 9.2271312,21.6353214 L2.7109026,15.1190928 C1.6171596,14.0253498 3.1566024,12.5428338 4.004721,13.3909524 L7.7315742,17.1872064 L4.4905266,13.8857922 L2.7865404,12.1500918 C1.3694562,10.7330076 3.3593994,9.2493576 4.300884,10.1908422 C2.4125094,8.3024676 4.4954406,6.9543684 5.5500606,8.0089506 L10.6118208,13.0707108",
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.4281934,
  y1: 5.421087,
  x2: 5.5344114,
  y2: 6.1126758,
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.5561484,
  y1: 3.3680934,
  x2: 3.0467934,
  y2: 0.9917586,
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.4595326,
  y1: 5.4829278,
  x2: 0.2238516,
  y2: 6.4359036,
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.8926828,
  y1: 4.3547112,
  x2: 1.2148542,
  y2: 3.4846686,
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 18.345096,
  y1: 3.9679794,
  x2: 18.2461356,
  y2: 1.5396696,
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 19.9341324,
  y1: 5.7428028,
  x2: 22.336776,
  y2: 6.1085556,
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 19.2334716,
  y1: 4.7581128,
  x2: 20.6415594,
  y2: 3.4974072,
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 9.0407394,
  y1: 15.0228162,
  x2: 4.0957056,
  y2: 9.9857016,
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.611783,
  y1: 13.0707108,
  x2: 5.5500228,
  y2: 8.0089506,
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.7109026,15.1190928 C1.6171596,14.0253498 3.1566024,12.5428338 4.004721,13.3909524 L7.7315742,17.1872064",
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.7865026,12.1500918 C1.3694184,10.7330076 3.3593616,9.2493576 4.3008462,10.1908422",
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.5500228,8.0089506 C4.4954028,6.9543306 2.4124716,8.3024298 4.3008462,10.1908422",
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.6993208,13.1002326 C16.865793,12.2917284 15.5567412,10.808721 13.6629612,8.9149788 C12.5006868,8.9149788 12.3675174,10.6409646 12.806451,11.7210618 L14.113386,13.0279968 L7.9485462,6.8631192 C6.968997,5.88357 5.1242058,7.5831714 6.3308952,8.7898608",
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.7865026,
  y1: 12.1500918,
  x2: 4.4904888,
  y2: 13.88583,
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.6993208,13.1002326 C20.0529378,15.4538496 20.0529378,19.2698352 17.6993208,21.62349 C15.3457038,23.9771448 11.5807104,23.9889762 9.2270934,21.6353592",
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.7109026,
  y1: 15.1190928,
  x2: 9.2270934,
  y2: 21.6353214,
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 10.3523994,
  y1: 7.4489436,
  x2: 9.5813928,
  y2: 2.1013776,
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 12.8817108,
  y1: 7.7938308,
  x2: 11.9232918,
  y2: 1.3679064,
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.4281934,5.421087 C5.193342,3.8922282 7.3115028,3.6075564 7.4936232,4.7930778 L7.5773502,5.4364338",
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.2454662,3.072006 C6.9411762,1.0911726 9.4232754,1.0721214 9.6254298,2.3881284",
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9232918,1.3679064 C11.696832,-0.1062558 9.2199492,-0.2514834 9.6254298,2.3881662",
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.6485922,12.306357 C18.4547916,11.1614328 18.3351924,9.5447268 17.9285778,6.8975928 C16.991478,6.2100486 15.8630724,7.5228804 15.5780604,8.653365 L14.5350072,1.8628974 C14.324688,0.493668 11.8318914,0.7727076 12.0909726,2.4594192",
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 7.2454662,
  y1: 3.072006,
  x2: 7.5389076,
  y2: 5.1301404,
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.4281934,
  y1: 5.421087,
  x2: 5.5344114,
  y2: 6.1126758,
  id: "Path",
  stroke: "#000000"
}), /*#__PURE__*/React.createElement("line", {
  x1: 3.5561484,
  y1: 3.3680934,
  x2: 3.0467934,
  y2: 0.9917586,
  id: "Path",
  stroke: "#FFFFFF"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.4595326,
  y1: 5.4829278,
  x2: 0.2238516,
  y2: 6.4359036,
  id: "Path",
  stroke: "#FFFFFF"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.8926828,
  y1: 4.3547112,
  x2: 1.2148542,
  y2: 3.4846686,
  id: "Path",
  stroke: "#FFFFFF"
}), /*#__PURE__*/React.createElement("line", {
  x1: 18.345096,
  y1: 3.9679794,
  x2: 18.2461356,
  y2: 1.5396696,
  id: "Path",
  stroke: "#FFFFFF"
}), /*#__PURE__*/React.createElement("line", {
  x1: 19.9341324,
  y1: 5.7428028,
  x2: 22.336776,
  y2: 6.1085556,
  id: "Path",
  stroke: "#FFFFFF"
}), /*#__PURE__*/React.createElement("line", {
  x1: 19.2334716,
  y1: 4.7581128,
  x2: 20.6415594,
  y2: 3.4974072,
  id: "Path",
  stroke: "#FFFFFF"
}))))));

var SvgClap = function SvgClap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "25px",
    viewBox: "0 0 23 25",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clap.bbb577fd.svg";
export { ForwardRef as ReactComponent };